import * as React from 'react';
import { UIText2 } from '@cian/ui-kit';
import { MetroMoscow16 } from '@cian/ui-kit/icons';
import { TRANSPORT_ICON_MAP } from './constants';
import * as styles from './Underground.css';
export var Underground = function Underground(_ref) {
  var color = _ref.color,
      name = _ref.name,
      transportType = _ref.transportType,
      time = _ref.time;
  var TransportIcon = transportType && TRANSPORT_ICON_MAP.get(transportType);
  return /*#__PURE__*/React.createElement("div", {
    className: styles['underground'],
    "data-testid": "underground"
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['info']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['icon'],
    style: {
      color: "#".concat(color)
    }
  }, /*#__PURE__*/React.createElement(MetroMoscow16, {
    color: 'current_color'
  })), /*#__PURE__*/React.createElement(UIText2, null, name)), TransportIcon && time && /*#__PURE__*/React.createElement("div", {
    className: styles['info'],
    "data-testid": "underground-time"
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['icon']
  }, /*#__PURE__*/React.createElement(TransportIcon, null)), /*#__PURE__*/React.createElement(UIText2, null, time)));
};